export const FETCH_SCORE_RULES_REQUEST = "FETCH_SCORE_RULES_REQUEST";
export const FETCH_SCORE_RULES_SUCCESS = "FETCH_SCORE_RULES_SUCCESS";
export const FETCH_SCORE_RULES_FAIL = "FETCH_SCORE_RULES_FAIL";
export const UPDATE_SCORE_RULE_REQUEST = "UPDATE_SCORE_RULE_REQUEST";
export const UPDATE_SCORE_RULE_SUCCESS = "UPDATE_SCORE_RULE_SUCCESS";
export const UPDATE_SCORE_RULE_FAIL = "UPDATE_SCORE_RULE_FAIL";
export const FETCH_SCORE_RULE_REQUEST = "FETCH_SCORE_RULE_REQUEST";
export const FETCH_SCORE_RULE_SUCCESS = "FETCH_SCORE_RULE_SUCCESS";
export const FETCH_SCORE_RULE_FAIL = "FETCH_SCORE_RULE_FAIL";
